import React, { Suspense, lazy, useEffect, useState } from "react";
import "@/index.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import AdminPage from "@/pages/AdminPage";
const StealthCode = lazy(() => import("@/pages/StealthCode"));
const PUBLIC_PAGES = {
  "/privacy-policy": lazy(() => import("@/pages/PrivacyPolicy")),
  "/support": lazy(() => import("@/pages/Support")),
};
import { Toaster } from "sonner";
import { Orb } from "@/components/Orb";

// "/?admin=<section>" works on any static host; "/admin" deep links are still accepted.
const isCodeRoute = () => new URLSearchParams(window.location.search).has("code");
const isAdminRoute = () => window.location.pathname.startsWith("/admin") || new URLSearchParams(window.location.search).has("admin");

function Gate() {
  const { user, ready } = useAuth();
  const [, rerender] = useState(0);
  useEffect(() => {
    const onNav = () => rerender((n) => n + 1);
    window.addEventListener("popstate", onNav);
    return () => window.removeEventListener("popstate", onNav);
  }, []);

  if (!ready || user === null) {
    return (
      <div className="stealth-bg min-h-screen flex items-center justify-center">
        <Orb state="thinking" size={160} />
      </div>
    );
  }
  if (user === false) return <Auth />;
  if (isAdminRoute()) {
    if (user.is_admin) return <AdminPage />;
    window.history.replaceState(null, "", "/"); // non-admins: the Admin area doesn't exist for them
  }
  if (!user.onboarded) return <Onboarding />;
  if (isCodeRoute()) {
    return <Suspense fallback={<div className="h-screen bg-black" />}><StealthCode /></Suspense>;
  }
  return <Dashboard />;
}

export default function App() {
  const Public = PUBLIC_PAGES[window.location.pathname.replace(/\/+$/, "")];
  if (Public) return <Suspense fallback={<div className="min-h-screen bg-black" />}><Public /></Suspense>;
  return (
    <AuthProvider>
      <Gate />
      <Toaster theme="dark" position="top-center" />
    </AuthProvider>
  );
}
